import PropTypes from "prop-types"
import { Form, Input } from "antd"
import { useState } from "react"
import { Text } from "ui/Typography"
import styles from "./index.module.css"

const TIP_PRESETS = ["10", "15", "20"]

const TipSection = ({ baseAmount, onTipChange }) => {
  const [selected, setSelected] = useState("none")
  const form = Form.useFormInstance()

  const handlePresetClick = (preset) => {
    setSelected(preset)
    if (preset === "none") {
      form.setFieldValue("tipCustomAmount", "")
      form.validateFields(["tipCustomAmount"])
      onTipChange(0)
    } else {
      const tip = (baseAmount * Number(preset)) / 100
      form.setFieldValue("tipCustomAmount", tip.toFixed(2))
      form.validateFields(["tipCustomAmount"])
      onTipChange(tip)
    }
  }

  const handleCustomChange = (e) => {
    setSelected("custom")
    const num = Number.parseFloat(e.target.value)
    onTipChange(Number.isNaN(num) || num < 0 ? 0 : num)
  }

  return (
    <div className={styles.container}>
      <Text className={styles.label}>ADD A TIP</Text>
      <div className={styles.presets}>
        {TIP_PRESETS.map((preset) => (
          <button
            key={preset}
            type="button"
            className={selected === preset ? styles.presetButtonActive : styles.presetButton}
            onClick={() => handlePresetClick(preset)}
          >
            {preset}%
          </button>
        ))}
        <button
          type="button"
          className={selected === "none" ? styles.presetButtonActive : styles.presetButton}
          onClick={() => handlePresetClick("none")}
        >
          None
        </button>
      </div>
      <Form.Item
        name="tipCustomAmount"
        className={styles.customInput}
        preserve={false}
        rules={[
          {
            validator: (_, value) => {
              if (!value && value !== 0) return Promise.resolve()
              const num = Number.parseFloat(value)
              if (!Number.isNaN(num) && num < 0) {
                return Promise.reject(new Error("Tip amount cannot be negative"))
              }
              return Promise.resolve()
            }
          }
        ]}
      >
        <Input
          prefix="$"
          type="number"
          min="0"
          placeholder="Custom tip amount"
          onChange={handleCustomChange}
        />
      </Form.Item>
    </div>
  )
}

TipSection.propTypes = {
  baseAmount: PropTypes.number.isRequired,
  onTipChange: PropTypes.func.isRequired
}

export default TipSection
